import AuthService from './AuthService';

const apiBase = String(process.env.REACT_APP_CHATBOT_API_URL || process.env.CHATBOT_API_URL || process.env.REACT_APP_API_URL || '').replace(/\/+$/, '');

async function request(clientId, id = '', method = 'GET', body, options = {}) {
    const base = clientId ? `/admin/clients/${encodeURIComponent(clientId)}/voicebots` : '/private/voicebots';
    const loginAs = !clientId && AuthService.getLoginAs();
    const url = `${apiBase}${base}${id ? `/${encodeURIComponent(id)}` : ''}${loginAs ? `?loginAs=${encodeURIComponent(loginAs)}` : ''}`;
    const response = await fetch(url, {
        method,
        signal: options.signal,
        headers: { Authorization: `Bearer ${AuthService.getAccessToken()}`, ...(body ? { 'Content-Type': 'application/json' } : {}) },
        ...(body ? { body: JSON.stringify(body) } : {}),
    });
    if (!response.ok) {
        const error = new Error('VoiceBot request failed');
        error.status = response.status;
        if (options.audio) {
            const payload = await response.json().catch(() => null);
            error.code = payload?.detail?.code;
        }
        throw error;
    }
    if (options.audio) return response.blob();
    return response.status === 204 ? null : response.json();
}

const voiceBotService = {
    preview: (clientId, voice, text, signal) => request(clientId, 'preview', 'POST', { voice, text }, { audio: true, signal }),
    list: (clientId) => request(clientId),
    save: (clientId, id, data) => request(clientId, id, id ? 'PUT' : 'POST', data),
    remove: (clientId, id) => request(clientId, id, 'DELETE'),
};
export default voiceBotService;
